import { Flex, Text } from '@chakra-ui/react';
import { PiFileDashedThin } from 'react-icons/pi';
import React from 'react';

const NoAvailable = () => {
  return (
    <Flex direction="column" justifyContent="center" alignItems="center" height="300" textAlign="center">
      <PiFileDashedThin fontSize="4rem" />
      <Text fontSize="xl" fontWeight="bold" mb="1">No hay datos para mostrar</Text>
      <Text fontSize="l">Continúa realizando transacciones para ver</Text>
      <Text fontSize="l">el análisis de tus movimientos.</Text>
    </Flex>
  );
}

export default NoAvailable
